import { Directive, Input, OnInit, Type, ViewContainerRef } from "@angular/core";

@Directive({
    selector: "[kno2ControlPanelItemBody]",
    standalone: false
})
export class ControlPanelItemBodyDirective implements OnInit {
    @Input() public component: Type<unknown>;
    @Input() public context?: Record<string, any>;

    constructor(private viewContainer: ViewContainerRef) {}

    public ngOnInit(): void {
        if (this.component) {
            const ref = this.viewContainer.createComponent(this.component);

            if (!this.context) return;

            Object.entries(this.context).forEach(([key, value]) => {
                (<any>ref.instance)[key] = value;
            });

            ref.changeDetectorRef.detectChanges();
        }
    }
}
